import React, { Component, createRef } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ScrollTop from "../containers/ScrollTop";
import Authorization from "../routes/Authorization";
import Callback from "../routes/Callback";
import AnimationScheduler from "../routes/Animations/AnimationScheduler";
import NewAnimation from "../routes/Animations/New";
import { Redirect } from "react-router-dom";
import SchedulerHeader from "../containers/SchedulerHeader";
import TasksScheduler from "../routes/Tasks/TasksScheduler";
import NewTask from "../routes/Tasks/New";
import Prints from "../routes/Prints/Prints";
import FetchContainer from "../containers/FetchContainer";
import AccessDenied from "../routes/AccessDenied";
import PrivateRoute from "./PrivateRoute";
import NotFound from "./NotFound";
import "@dod/menu/web-component/menu.css";
import "@dod/menu/web-component/menu.js";
import { filterMenuConfigByPermissions } from "../utils/filterMenuByPermissions";
import userManager from "../utils/userManager";

class RouterComponent extends Component {
   sidebarRef = createRef();

   async componentDidMount() {
      const sidebar = this.sidebarRef.current;
      if (sidebar) {
         const env = window.location.href.includes("test") ? "test" : "prod";
         const userId = await userManager
            .getUser()
            .then((user) => {
               if (user && user.profile && user.profile.sub) {
                  return user.profile.sub;
               }
               return null;
            })
            .catch(() => null);
         const menuConfig = await filterMenuConfigByPermissions(userId);
         sidebar.dodPlatform = false;
         sidebar.env = env;
         sidebar.menuConfig = userId ? menuConfig : [];

         userManager.events.addUserLoaded(async (user) => {
            const newUserId = user && user.profile && user.profile.sub ? user.profile.sub : null;
            const newMenuConfig = await filterMenuConfigByPermissions(newUserId);
            sidebar.menuConfig = newUserId ? newMenuConfig : [];
         });
      }
   }

   render() {
      return (
         <div>
            <FetchContainer />
            <Router>
               <div>
                  <SchedulerHeader />
                  <ScrollTop>
                     <div className="flex position-relative">
                        <sidebar-navigation
                           id="sidebar-navigation"
                           class="sidebar-navigation-wrapper"
                           ref={this.sidebarRef}
                        ></sidebar-navigation>
                        <Switch>
                           <Route exact path="/login" component={Authorization} />
                           <Route exact path="/sign-in" component={Callback} />
                           <Redirect exact from="/" to="/tasks-scheduler" />
                           <PrivateRoute
                              exact
                              path="/animation-scheduler"
                              component={AnimationScheduler}
                              requiredPermission="harmonogramAnimacji"
                           />
                           <PrivateRoute
                              path="/animation-scheduler/new"
                              component={NewAnimation}
                              requiredPermission="harmonogramAnimacji"
                           />
                           <PrivateRoute
                              exact
                              path="/tasks-scheduler"
                              component={TasksScheduler}
                              requiredPermission="harmonogramRezydentow"
                           />
                           <PrivateRoute
                              path="/tasks-scheduler/new"
                              component={NewTask}
                              requiredPermission="harmonogramRezydentow"
                           />
                           <PrivateRoute
                              path="/prints"
                              component={Prints}
                              requiredPermission="wydruki"
                           />
                           <Route path="/access-denied" component={AccessDenied} />
                           <Route component={NotFound} />
                        </Switch>
                     </div>
                  </ScrollTop>
               </div>
            </Router>
         </div>
      );
   }
}

export default RouterComponent;
